module.exports = __webpack_public_path__ + "img/home-landing-smart-diaper.6fddd749.svg";